module.exports = __webpack_public_path__ + "img/www.openrice.com.5f9bcbab.png";